<template>
	<component :is="layout" />
</template>
<script>
	import User from './layouts/User.vue'; // 사용자화면 레이아웃
	import Admin from './layouts/Admin.vue'; // 관리자화면 레이아웃
	import Blank from './layouts/Blank.vue'; // 빈화면 레이아웃

	export default
	{
		name: 'App',
		components:
		{
			User,
			Admin,
			Blank
		},
		data()
		{
			return {
				layout: null
			}
		},
    watch: {
      $route(to) {
        if (to.meta.layout === undefined) {
          this.layout = "User"
        } else {
          this.layout = to.meta.layout
        }

        if (to.meta.title) {
          document.title = to.meta.title
        } else {
          document.title = "Dot Account"
        }
      }
    },
	}
</script>

<style>
@font-face {
	font-family: 'goudy-old-style';
	src: url('assets/fonts/goudos.woff2') format('woff2');
}

  #app {
    font-family: goudy-old-style, Georgia, serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

    position: absolute;
    width: 100dvw;
    height: 100dvh;
    top: 0;
    left: 0;

    align-content: center;

    margin: 0;
    padding: 0;

    overflow: hidden;
  }
</style>
